export const API_URL = "https://thiqa.shaalan.dev" as string;
export const SOCKET_API_URL = "https://qri.alghad.fm" as string;
